<div class="quiz-result">
  <div class="quiz-result__body">
    <div class="quiz-result__body-header">
      @if (result().passed) {
        <app-enfaf-icon svgIconName="smile" iconSize="32px"></app-enfaf-icon>
        <div class="quiz-result__body-header-text">Aprobado: {{ result().correctCount }}/{{ result().total }}</div>
      } @else {
        <app-enfaf-icon svgIconName="frown" iconSize="32px"></app-enfaf-icon>
        <div class="quiz-result__body-header-text">Suspenso: {{ result().correctCount }}/{{ result().total }}</div>
      }
    </div>

    <div class="quiz-result__body-message">
      @if (result().passed) {
        <p>¡Enhorabuena has acertado todas las preguntas!</p>
      } @else {
        <p> Parece que aún tienes que repasar el temario. <br />¡Ánimo ya casi lo tienes!</p>
      }
    </div>
  </div>

  <div class="quiz-result__actions">
    @if (result().passed) {
      <app-enfaf-button type="modal-primary" (onClick)="onContinue()">Ir a la siguiente clase</app-enfaf-button>
    } @else {
      <app-enfaf-button type="modal-outline" (onClick)="onRewatch()">Volver a ver la clase</app-enfaf-button>
      <app-enfaf-button type="modal-primary" (onClick)="onContinue()">Continuar</app-enfaf-button>
    }
  </div>
</div>
